import React from 'react'
import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from '../../../components'
import {
  PragmaticApproachWellBeingImage,
  ExecutiveLeadershipPhysicianWellBeingImage,
  BurnoutMeasuresChartImage
} from 'assets'

// TODO: Import images from assets

export const ProvidersBurnoutSolutionsPage: React.FC = () => {
  const burnoutChecklistItems = [
    'Routine staff meetings with time for staff to share concerns',
    'Yearly retreats',
    'Have a Comprehensive Unit-based Safety Program (CUSP Team)',
    'Have providers rotate between seeing patients in the outpatient and inpatient clinic (Allows providers to see patients doing well at times)',
    'Support team through patient losses',
    'Team Huddles as needed after a tough or great day',
    'Support team members when patients display inappropriate behavior (Team safety always comes first – make sure your team knows that!)',
    'Leadership have an open door policy to hear concerns and act on them if needed',
    'Express gratitude and encourage the public expression of gratitude'
  ]

  return (
    <ToolkitPageLayout
      title="Burnout Solutions"
      breadcrumbs={[
        { label: 'Toolkit', path: '/toolkit' },
        { label: 'Providers', path: '/toolkit/providers' },
        {
          label: 'Burnout Solutions',
          path: '/toolkit/providers/burnout-solutions'
        }
      ]}
    >
      <div className="prose max-w-none text-[#3C2416]">
        <blockquote className="border-l-4 border-[#A6410A] pl-4 italic my-8">
          <p>
            The goal is to identify strategies to identify, mitigate and
            ultimately prevent burnout among your infusion center providers.
          </p>
        </blockquote>

        <hr className="my-8" />

        <p className="text-xl font-semibold mb-2">
          1. Read the following article:
        </p>
        <figure className="mb-8 text-center">
          <a
            href="https://nam.edu/a-pragmatic-approach-for-organizations-to-measure-health-care-professional-well-being/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block border border-gray-300 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-200"
            aria-label="Read A Pragmatic Approach for Organizations to Measure Health Care Professional Well-Being"
          >
            <img
              src={PragmaticApproachWellBeingImage}
              alt="A Pragmatic Approach for Organizations to Measure Health Care Professional Well-Being"
              className="max-w-full h-auto md:max-w-2xl rounded-lg shadow-md"
            />
          </a>
          <figcaption className="mt-2 text-sm text-gray-600">
            <em>
              A Pragmatic Approach for Organizations to Measure Health Care
              Professional Well-Being,{' '}
            </em>
            Liselotte N. Dyrbye
          </figcaption>
        </figure>

        <p className="text-xl font-semibold mb-2">
          2. Read the following article:
        </p>
        <figure className="mb-8 text-center">
          <a
            href="https://nam.edu/clinicianwellbeing/resources/executive-leadership-and-physician-well-being-nine-organizational-strategies-to-promote-engagement-and-reduce-burnout/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block border border-gray-300 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-200"
            aria-label="Read Executive Leadership and Physician Well-being: Nine Organizational Strategies to Promote Engagement and Reduce Burnout"
          >
            <img
              src={ExecutiveLeadershipPhysicianWellBeingImage}
              alt="Executive Leadership and Physician Well-being"
              className="max-w-full h-auto md:max-w-2xl rounded-lg shadow-md"
            />
          </a>
          <figcaption className="mt-2 text-sm text-gray-600">
            <em>
              Executive Leadership and Physician Well-being: Nine Organizational
              Strategies to Promote Engagement and Reduce Burnout
            </em>
            , Tait D. Shanafelt, MD and John H. Noseworthy, MD.
          </figcaption>
        </figure>

        <p className="text-xl font-semibold mb-2">
          3. Review chart below on burnout measures and choose one to utilize
          with your staff:
        </p>
        <figure className="mb-8 text-center">
          <a
            href="https://nam.edu/wp-content/uploads/2018/10/Pragmatic-Table-2-1.png"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block border border-gray-300 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-200"
            aria-label="Review chart on burnout measures"
          >
            <img
              src={BurnoutMeasuresChartImage}
              alt="Chart on burnout measures"
              className="max-w-full h-auto md:max-w-2xl rounded-lg shadow-md"
            />
          </a>
          <figcaption className="mt-2 text-sm text-gray-600">
            Source: Dyrbye et al.,{' '}
            <em>
              Pragmatic Approach for Organizations to Measure Health Care
              Professional Well-Being.
            </em>
          </figcaption>
        </figure>

        <p className="text-xl font-semibold mt-10 mb-4">
          4. Review the following burnout checklist on a regular basis:
        </p>
        <div className="not-prose bg-white p-6 rounded-lg shadow-md border border-gray-200 mb-8">
          <ul className="list-disc pl-5 space-y-3">
            {burnoutChecklistItems.map((item, index) => {
              const parts = item.split(' (')
              const mainText = parts[0]
              const subText = parts[1] ? `(${parts[1]}` : null
              return (
                <li key={index} className="text-[#3C2416]">
                  <span className="font-medium">{mainText}</span>
                  {subText && (
                    <span className="text-sm text-[#713d43] ml-1">
                      {subText}
                    </span>
                  )}
                </li>
              )
            })}
          </ul>
        </div>

        <hr className="my-12" />

        <div className="mt-12 mb-8 text-center">
          <Link
            to="/toolkit/providers"
            className="bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-6 py-3 text-lg font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
          >
            All done? Click here to return to the Providers screen
          </Link>
        </div>
      </div>
    </ToolkitPageLayout>
  )
}
